module.exports = __webpack_public_path__ + "img/108.11e04f67.svg";